import React from 'react';
import { withRouter } from 'react-router-dom';
import cn from "classnames";

const ItemRow = ({ item, onEdit, onDelete }) => {
    return (
        <tr key={`${item.id}_item`} className="kt-datatable__row">
            <td width="45px" className="kt-datatable__cell">
                <span>{item.id}</span>
            </td>
            <td width="280px" className="kt-datatable__cell">
                <span>{item.name || "Не указан"}</span>
            </td>
            <td align="right" width="180px" className="kt-datatable__cell">
                <button
                    data-tip="Редактирование"
                    className="btn btn-sm btn-clean btn-icon btn-icon-md"
                    onClick={() => onEdit(item)}
                >
                    <i className="la la-edit"></i>
                </button>
                <button
                    data-tip="Удалить"
                    className={cn("btn btn-sm btn-clean btn-icon btn-icon-md")}
                    onClick={() => onDelete(item)}
                >
                    <i className="la la-trash"></i>
                </button>
            </td>
        </tr>
    );
};

export default withRouter(ItemRow);
